// extracted by mini-css-extract-plugin
export default {"reportPriceContainer":"reportPrice_reportPriceContainer__VLKwh"};